import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { showDefaultErrorToast } from '@app/utils';
import { useGoogleLogin } from '@data/hooks';
import { antdNotification } from '@ui/components';

type GoogleSignInButtonProps = {
  width: number;
};

export const GoogleSignInButton = ({ width }: GoogleSignInButtonProps) => {
  const { t } = useTranslation();
  const { mutate } = useGoogleLogin();
  const {
    i18n: { language },
  } = useTranslation();

  const googleSignIn = async (credentials: CredentialResponse) => {
    const { credential: idToken } = credentials;
    if (!idToken) return;

    mutate(
      { idToken },
      {
        onError: (err) => {
          if (err?.response?.status === 404) {
            // Handle user not found
            antdNotification.error({
              title: t('beErrors.User not found'),
            });
          } else {
            showDefaultErrorToast(err);
          }
        },
      },
    );
  };

  return (
    <GoogleLogin
      size="large"
      onSuccess={googleSignIn}
      text="signin_with"
      locale={language}
      width={width}
      shape="pill"
    />
  );
};
